import './App.css';
import { Router } from './navigation/routes';
import './index.scss'


function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Router />
      </header>
    </div>
  );
}

export default App;